export const verifyPhoneNumber = (value) => {
  var phonenumberRex = /^\d{2,3}-\d{3,4}-\d{4}$/;
  var phone1588Rex = /^\d{4}-\d{4}$/;
  if (phonenumberRex.test(value) || phone1588Rex.test(value)) {
    return true;
  }
  return false;
}

export const verifyEmail = (value) => {
  var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
}

export const verifyLength = (value, params) => {
  const { minLength = 0, maxLength = Number.MAX_SAFE_INTEGER } = params;
  if (value.length >= minLength && value.length <= maxLength) {
    return true;
  }
  return false;
}

export const verifyNumber = (value, params = {}) => {
  const { minNumber = 0, maxNumber = Number.MAX_SAFE_INTEGER } = params;
  const numberRex = /\d+/;
  const numberVal = Number(value);
  if (numberRex.test(value) && numberVal >= minNumber && numberVal <= maxNumber) {
    return true;
  }
  return false;
}

export const verifyDate = (value) => {
  const dateRex = /\d+-\d+-\d/;
  return dateRex.test(value);
}